
import { Component, Vue } from 'vue-property-decorator';
import OrderSearch from './components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { ViewType, OrderServiceStage } from '@/types/orderServicer';

@Component({
  name: 'orderServicerHang',
  components: {
    OrderSearch,
    OrderList
  }
})
export default class extends Vue {
  private stageSub = OrderServiceStage.SERVICE_STAGE_SUB_HANDUP;
  private vt = ViewType.ORDER_SERVICER_HANG;
}
